import { Warehouse } from '@models/next/Warehouse';
import { z } from 'zod';

export const ServiceName = z.enum([
  'D2D',
  'D2DSHENZHEN+',
  '海上速達便',
  'D2DSHENZHEN',
  'D2DQINGDAO',
]);

export type ServiceName = z.infer<typeof ServiceName>;

export const RoutePlanSchedule = z.object({
  warehouse_closing_date: z.number(),
  etd: z.number(),
  eta: z.number(),
  pickup_date: z.number(),
});

export type RoutePlanSchedule = z.infer<typeof RoutePlanSchedule>;

export const RoutePlanFields = z.object({
  id: z.number(),
  plan_id: z.number(),
  /**
   * @example "A", "B", "C"
   */
  option_id: z.string(),
  name: z.string(),
  service_name: ServiceName,
  receiving_city: z.string(),
  pol: z.string(),
  pod: z.string(),
  schedules: RoutePlanSchedule.array().nullish(),
  receiving_warehouses: Warehouse.array(),
  export_warehouse: Warehouse,
  created_at: z.string(),
  updated_at: z.string(),
});

export const RoutePlan = RoutePlanFields.pick({
  id: true,
  plan_id: true,
  option_id: true,
  name: true,
  service_name: true,
  receiving_city: true,
  pol: true,
  pod: true,
  schedules: true,
  receiving_warehouses: true,
  export_warehouse: true,
  created_at: true,
  updated_at: true,
});

export type RoutePlan = z.infer<typeof RoutePlan>;
